import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MTopBar } from "@/components/mobile/MTopBar";
import { MPage, SearchBox, Loading, EmptyArt, cardCls } from "@/components/mobile/parts";
import { useOpenComandas } from "@/hooks/useMobileData";
import { MineToggle, useMine } from "@/components/mobile/MineToggle";
import { brl } from "@/lib/api";
import { filterComandas } from "@/lib/mobile";
import { cn } from "@/lib/utils";

export default function MComandas() {
  const { list } = useOpenComandas();
  const [q, setQ] = useState("");
  const nav = useNavigate();
  const { enabled, mine, setMine, apply } = useMine();
  const shown = filterComandas(apply(list || []), q);
  return (
    <>
      <MTopBar title="Comandas" />
      <MPage>
        <SearchBox value={q} onChange={setQ} placeholder="Buscar por número ou nome" testId="m-comandas-search" />
        {enabled && <MineToggle mine={mine} setMine={setMine} count={shown.length} />}
        {!list ? <Loading /> : !list.length ? <EmptyArt title="Nenhuma comanda aberta" text="As comandas abertas aparecem aqui." testId="m-comandas-empty" /> : (
          <div className={cn(cardCls, "overflow-hidden")}>
            <table className="w-full text-sm" data-testid="m-comandas-table">
              <thead className="bg-[#e3f2fd] text-left text-[11px] uppercase tracking-wider text-[#0d47a1]">
                <tr><th className="px-3 py-2.5">Comanda</th><th className="px-2">Mesa</th><th className="px-2 text-right">Valor</th><th className="px-3">Cliente</th></tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {shown.map((c) => (
                  <tr key={c.id} onClick={() => nav(`/m/comanda/${c.id}`)} className="cursor-pointer active:bg-slate-50" data-testid={`m-comanda-row-${c.number}`}>
                    <td className="px-3 py-3.5 font-mono font-bold text-[#0d47a1]">#{c.number}</td>
                    <td className="px-2">{c.table_number || "—"}</td>
                    <td className="px-2 text-right font-mono font-semibold">{brl(c.total)}</td>
                    <td className="max-w-[120px] truncate px-3">{c.customer_name || "—"}{enabled && <span className="block truncate text-[11px] text-[#1565c0]" data-testid={`m-comanda-row-waiter-${c.number}`}>Garçom: {c.opened_by || "—"}</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!shown.length && <p className="py-8 text-center text-sm text-slate-500">Nenhuma comanda encontrada.</p>}
          </div>
        )}
      </MPage>
    </>
  );
}
